var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"map"}},[_c('v-row',{attrs:{"justify":"end"}},[_c('v-btn',{staticClass:"move__btn",on:{"click":function($event){return _vm.move()}}},[_c('v-icon',{attrs:{"color":"#3a4f4f"}},[_vm._v(" mdi-webcam ")]),_vm._v(" 악취제어 모니터링 ")],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }